import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { SMS_DESTINATION_NUMBER } from '@src/constants/mobifone';
import WarningIcon from '@src/assets/icons/warning-orange.svg';
import { getPackageCurrentPrice } from '@src/services/package';
import { redirectToSMSApp } from '@src/services/sms';

import { StyledPaymentSMSDialog } from './index.style';

const SMSRegisterDialog = ({ packageState, openDialog, setOpenDialog }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const { user } = useSelector((state) => state.auth);
  const { price } = getPackageCurrentPrice(packageState, true);
  const { phoneNumber: phoneNumberState = '' } = useSelector(
    (state) => state.order.userOrder,
  );

  const initPhoneNumber =
    phoneNumberState || user?.phoneNumber || user.firstName;

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <StyledPaymentSMSDialog open={openDialog} onClose={handleClose}>
      <div className="wrapper">
        <Box className="header">
          <Typography className="title">{t('buyPackage')}</Typography>
          <Box onClick={handleClose}>
            <CloseIcon className="close-icon" />
          </Box>
        </Box>
        <Box className="payment-info">
          <Box className="payment-info-item">
            <Box className="payment-info-key">{t('account')}</Box>
            <Box className="payment-info-value">{`${user?.lastName || ''} ${
              user?.firstName || ''
            }`}</Box>
          </Box>

          <Box className="payment-info-item">
            <Box className="payment-info-key">{t('phoneNumber')}</Box>
            <Box className="payment-info-value">{initPhoneNumber}</Box>
          </Box>

          <Box className="payment-info-item">
            <Box className="payment-info-key">{t('pack')}</Box>
            <Box className="payment-info-value">{packageState?.name?.vi}</Box>
          </Box>

          <Box className="payment-info-item">
            <Box className="payment-info-key">{t('paymentSum')}</Box>
            <Box className="payment-info-value">
              <span className="unit-vn">đ</span>
              <span className="price">{price?.toLocaleString(language)}</span>
            </Box>
          </Box>
        </Box>
        <Box className="payment-syntax-container">
          <Box className="payment-syntax-title">{t('smsGuide')}</Box>
          <Box className="payment-syntax-content">
            DK {packageState?.paymentHub?.basePlanId}{' '}
            <span className="send-text">{t('lowercaseSend')}</span>{' '}
            {SMS_DESTINATION_NUMBER}
          </Box>
        </Box>
        <Box className="payment-note">({t('syntaxSMSNote')})</Box>
        <Box className="payment-warning">
          <img className="img-icon-warning" src={WarningIcon} alt="warning" />
          <Box>
            {t('smsWarn')} {phoneNumberState} {t('toPurchaseSMS')}.
          </Box>
        </Box>
        <Box className="mobile-sms">
          {redirectToSMSApp({
            body: `DK ${packageState?.paymentHub?.basePlanId}`,
            target: SMS_DESTINATION_NUMBER,
            content: (
              <Button onClick={handleClose} className="button-sms">
                {t('composeSMS')}
              </Button>
            ),
          })}
        </Box>
      </div>
    </StyledPaymentSMSDialog>
  );
};

export default SMSRegisterDialog;
